import { clearForm, resetStepper } from '../slice/checkoutSlice';
import { debounce, switchMap } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { onAuthLogin, onAuthLogout } from '../slice/authSlice';
import { pushEventToDataLayer } from '../../utils/dataLayerUtils';
import { timer } from 'rxjs';
import { updatedPersonalDetails } from '../slice/profileSlice';
import { DataLayerEventName } from '../../types/data-layer';

export const checkoutEpic: Epic = (action$) =>
  action$.pipe(
    ofType(onAuthLogin.type, onAuthLogout.type, updatedPersonalDetails.type),
    debounce(() => timer(50)),
    switchMap(async (e) => {
      if (e.type === onAuthLogin.type || e.type === onAuthLogout.type) {
        if (e.type === onAuthLogin.type) {
          // Push login event in data layer
          pushEventToDataLayer({type: DataLayerEventName.SIGN_IN});
        }
        return clearForm();
      } else {
        return resetStepper();
      }
    }),
  );
